import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Icon, Typography } from '@americanexpress/aqx-components';
import { getCombinedG179Data } from './redux';
import styles from './__styles__/index.scss?modules';

const AffiliateBanner = ({ isAffiliatePgMode, bannerData }) => {
  useEffect(
    () => {
      const clsName = 'g179';
      if (isAffiliatePgMode) {
        document.body.classList.add(clsName);
      } else {
        document.body.classList.remove(clsName);
      }

      return () => {
        document.body.classList.remove(clsName);
      };
    },
    [isAffiliatePgMode]
  );

  const { bannerAmexLogo, bannerTitle, url, alt } = bannerData || {};

  return (
    <div className={styles.affiliateBanner}>
      <div className={styles.affiliateInner}>
        <Icon
          className={styles.amexLogo}
          directory={bannerAmexLogo?.directory}
          hiddenToScreenReaders="true"
          imageName={bannerAmexLogo?.imageName}
        />
        <div className={styles.contentBlock}>
          <Typography Component="div" className={styles.bannerTitle}>
            {bannerTitle}
          </Typography>
          <div className={styles.logoHolder}>
            <img src={url} alt={alt} />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...getCombinedG179Data(state)
  };
};

export default connect(mapStateToProps)(React.memo(AffiliateBanner));
